// extracted by mini-css-extract-plugin
export var formContainer = "_ja-0";
export var message = "_ja-1";